// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 4 hooks for backend/insurance.

import { useBackend } from '../useBackend'

/** POST /api/insurance/getInsuranceCover */
export function useGetInsuranceCover<T = any>() {
  return useBackend<T>('insurance/getInsuranceCover')
}

/** POST /api/insurance/openInsuranceSchedule */
export function useOpenInsuranceSchedule<T = any>() {
  return useBackend<T>('insurance/openInsuranceSchedule')
}

/** POST /api/insurance/setAsideInsuranceSchedule */
export function useSetAsideInsuranceSchedule<T = any>() {
  return useBackend<T>('insurance/setAsideInsuranceSchedule')
}

/** POST /api/insurance/uploadInsuranceSchedule */
export function useUploadInsuranceSchedule<T = any>() {
  return useBackend<T>('insurance/uploadInsuranceSchedule')
}
